import { packRules, unpackRules } from '@casl/ability/extra';
import { createPrismaAbility } from '@casl/prisma/runtime';
/** Compact JSON form of the caller's rules, for the web app. */
export function packAbility(ability) {
    return packRules(ability.rules);
}
/**
 * Rebuilds an ability from packed rules, for checks on plain objects.
 *
 * Rules with relation conditions (the org scope reads `property.ownerId`)
 * only match objects that carry those relations, and API DTOs carry ids, not
 * relations. Clients should ask subject-level questions such as
 * `can('update', 'Deal')` for menus and buttons, and take per-record
 * decisions from the server.
 */
export function abilityFromPacked(packed) {
    return createPrismaAbility(unpackRules(packed));
}
